import { render, staticRenderFns } from "./OrderDialogue.vue?vue&type=template&id=50b038ac&"
import script from "./OrderDialogue.vue?vue&type=script&lang=ts&"
export * from "./OrderDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports